import { PaymentMethod } from '../enum/payment-method.enum';
import { PaymentStatus } from '../enum/payment-status.enum';

export interface MasterPaymentUserRef {
  _id: string;
  name?: string;
  email?: string;
}

export interface MasterPaymentOrderRef {
  _id: string;
  orderNumber?: string;
  amount?: number;
}

export interface MasterPayment {
  _id: string;
  userId: MasterPaymentUserRef | string;
  orderId: MasterPaymentOrderRef | string;
  amount: number;
  currency: string;
  paymentMethod: PaymentMethod | string;
  status: PaymentStatus | string;
  transactionId?: string;
  gatewayResponse?: Record<string, unknown>;
  failureReason?: string;
  paidAt?: string;
  refundedAt?: string;
  refundAmount?: number;
  refundReason?: string;
  isRefunded: boolean;
  metadata?: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
}

export function masterPaymentUser(payment: MasterPayment): MasterPaymentUserRef | null {
  if (!payment?.userId) {
    return null;
  }
  return typeof payment.userId === 'string' ? { _id: payment.userId } : payment.userId;
}

export function masterPaymentOrder(payment: MasterPayment): MasterPaymentOrderRef | null {
  if (!payment?.orderId) {
    return null;
  }
  return typeof payment.orderId === 'string' ? { _id: payment.orderId } : payment.orderId;
}
